// extracted by mini-css-extract-plugin
export var pillWrapper = "_oz-0";
export var showOverflow = "_oz-1";